import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import ViewIcon from "@material-ui/icons/Visibility";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import {
  getSmartChronologyFileUrl,
} from "../../../../Services/DocumentAccessService";
import { downloadFile, viewPdfInNewTab } from "../../../../Services/FileService";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const styles = (theme) => ({
  arrowDropDownIcon: {
    color: "white",
  },
  Button: {
    backgroundColor: "#f39c12",
    color: "white",
    textTransform: "none",
    with: "200px",
    "&:hover": {
      backgroundColor: "#d2850b",
      borderColor: "#be780a",
    },
  },
  menuTitle: {
    paddingRight: 10,
    borderRight: "2px solid white",
  },
  menuItem: {
    color: "#f39c12",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  notReady: {
    color: "#dbd8d4",
    "&:hover": {
      backgroundColor: "#fff",
    },
    cursor: "default",
  },
});

const RecordChronologyMenu = (props) => {
  const {
    classes,
    orderId,
    orderNumber,
    isDownloadAllowed,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  const [btnOpening, setBtnOpening] = useState(false);

  const [btnDownloading, setBtnDownloading] = useState(false);
  const [completedDownload, setCompletedDownload] = useState(0);
  const [variantDownload, setVariantDownload] = useState("indeterminate");

  const handleToggle = async (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  const handleDropClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleDownloadFile = async () => {
    const urlResponse = await getSmartChronologyFileUrl(orderId);
    
    await downloadFile(
      urlResponse.data,
      `${orderNumber} smart-chronology.pdf`,
      btnDownloading,
      setBtnDownloading,
      setVariantDownload,
      setCompletedDownload
    );
  };

  const handleViewFile = async () => {
    try {
      setBtnOpening(true);
      const urlResponse = await getSmartChronologyFileUrl(orderId);
      
      await viewPdfInNewTab(
        urlResponse.data, 
        setBtnOpening,
        `${orderNumber} smart-chronology.pdf`
      );
    } catch (e) {
      console.error(e);
      setBtnOpening(false);
    }
  };

  return (
    <div>
      <Button
        data-testid="handleToggle"
        onClick={handleToggle}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        className={classes.Button}
      >
        <Typography className={classes.menuTitle}>Record Chronology</Typography>
        <ArrowDropDownIcon className={classes.arrowDropDownIcon} />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleDropClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        getContentAnchorEl={null}
        anchorReference="anchorEl"
        PaperProps={{
          style: {
            width: "200px",
            border: "1px solid #f9f9f9",
          },
        }}
      >
        <MenuItem
          data-testid="handleViewFile"
          onClick={handleViewFile}
          disabled={btnOpening}
          className={classes.menuItem}
          key="viewFile"
        >
          {btnOpening ? (
            <>
              <CircularProgress color="inherit" size={24} thickness={8} />
              preparing...
            </>
          ) : (
            <>
              <ViewIcon />
              View
            </>
          )}
        </MenuItem>
        ,
        <MenuItem
          data-testid="handleDownloadFile"
          onClick={handleDownloadFile}
          disabled={!isDownloadAllowed || btnDownloading}
          className={classes.menuItem}
          key="downloadFile"
        >
          {btnDownloading ? (
            <>
              <CircularProgress
                color="inherit"
                size={24}
                thickness={8}
                variant={variantDownload}
                value={completedDownload}
              />
              preparing...
            </>
          ) : (
            <>
              <ArrowDownward />
              Download
            </>
          )}
        </MenuItem>
      </Menu>
    </div>
  );
};

RecordChronologyMenu.propTypes = {
  classes: PropTypes.object.isRequired,
  orderId: PropTypes.string.isRequired, // GUID from C#
  orderNumber: PropTypes.string.isRequired, // String from C#
  isDownloadAllowed: PropTypes.bool.isRequired
};

export default withStyles(styles)(RecordChronologyMenu);
